import { render, staticRenderFns } from "./MatterRow.vue?vue&type=template&id=7ce3fd34&scoped=true"
import script from "./MatterRow.vue?vue&type=script&lang=js"
export * from "./MatterRow.vue?vue&type=script&lang=js"
import style0 from "./MatterRow.vue?vue&type=style&index=0&id=7ce3fd34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce3fd34",
  null
  
)

export default component.exports